import { formatGradesRangeOrList } from "@nimble/ts-formatters/format-grade-range";

import { getInitials } from "@/lib/helpers/initials";

const MESSAGE_PREVIEW_LENGTH = 50;

export function normalizeBrToNewline(text: string): string {
  return text.replace(/<br\s*\/?>/gi, "\n");
}

export function formatMatchedGradesDisplay(
  grades: string[] | undefined,
): string {
  if (!grades || grades.length === 0) return "";
  if (grades.length === 1) return `Grade ${grades[0]}`;
  return `Grades ${formatGradesRangeOrList(grades)}`;
}

export function formatDistanceLabel(
  distanceFromSchool: number | null | undefined,
  milesWithin: number | null,
): string | null {
  if (distanceFromSchool == null || milesWithin == null) return null;
  if (distanceFromSchool > milesWithin) return null;
  return `${distanceFromSchool.toFixed(1)} miles away`;
}

export function buildPrincipalInitials(
  firstName?: string,
  lastName?: string,
): string {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  return fullName ? getInitials(fullName) : "P";
}

export function truncateToPreviewLength(message: string | undefined): string {
  if (!message) return "";
  const normalized = normalizeBrToNewline(message);
  if (normalized.length <= MESSAGE_PREVIEW_LENGTH) return normalized;
  return normalized.substring(0, MESSAGE_PREVIEW_LENGTH) + "...";
}
